import { render, staticRenderFns } from "./SubselectionCategory.vue?vue&type=template&id=9ae7cb74&scoped=true&"
import script from "./SubselectionCategory.vue?vue&type=script&lang=js&"
export * from "./SubselectionCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubselectionCategory.vue?vue&type=style&index=0&id=9ae7cb74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae7cb74",
  null
  
)

export default component.exports